import customAxios from "../../customAxios";
import { DELETE_FINANCIAL_GROUP } from "../../routes";

const deleteFinancialGroup = async (Id: string) => {
  try {
    return (await customAxios.delete(DELETE_FINANCIAL_GROUP + `/${Id}`)).data;
  } catch (error: any) {
    console.log({ DELETE_SUPER_AGENT: error });
    return false;
  }
};

export default deleteFinancialGroup;
